import { parseAsInteger, useQueryState } from "nuqs";

export const useQtyState = () => {
  const [qty, setQty] = useQueryState(
    "qty",
    parseAsInteger.withDefault(1),
  );

  const onPlus = () => {
    setQty((oldQty) => {
      return oldQty + 1;
    });
  };
  const onMinus = () => {
    setQty((oldQty) => {
      let v = oldQty - 1;
      if (v < 1) {
        v = 1;
      }
      return v;
    });
  };

  return {
    onMinus,
    onPlus,
    qty,
    setQty,
  };
};
